import { createIcon } from './createIcon'

export const EyeSlashedOutIcon = createIcon({
  displayName: 'EyeSlashedOut',
  viewBox: '0 0 20 21',
  path: [
    <path
      d="M11.7678 12.0324C12.2366 11.5636 12.5 10.9277 12.5 10.2646C12.5 9.60161 12.2366 8.96572 11.7678 8.49688C11.2989 8.02804 10.663 7.76465 10 7.76465C9.33696 7.76465 8.70107 8.02804 8.23223 8.49688C7.76339 8.96572 7.5 9.60161 7.5 10.2646C7.5 10.9277 7.76339 11.5636 8.23223 12.0324C8.70107 12.5013 9.33696 12.7646 10 12.7646C10.663 12.7646 11.2989 12.5013 11.7678 12.0324Z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <path
      d="M2.04834 10.2646C3.11001 6.88377 6.26917 4.43127 10 4.43127C13.7317 4.43127 16.89 6.88377 17.9517 10.2646C16.89 13.6454 13.7317 16.0979 10 16.0979C6.26917 16.0979 3.11001 13.6454 2.04834 10.2646Z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <path
      d="M3.64648 16.9111L16.6465 3.911132"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />,
  ],
})
